module.exports = __webpack_public_path__ + "static/img/4.45b9238.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/4.png
// module id = upT4
// module chunks = 0